<style lang="scss" src='./McLanguage.scss'></style>
<template src="./McLanguage.html"></template>

<script>
import { mapState, mapMutations } from 'vuex';
import { updateMe } from '@/api/index';

export default {
  name: 'McLanguage',
  components: {
  },
  data() {
    return ({
      loading: {
        lang: false,
      },
      languages: [
        {
          image: 'usa',
          value: 'en',
          i18n: 'lang.english',
        },
        {
          image: 'newzealand',
          value: 'en_nz',
          i18n: 'lang.english',
        },
        {
          image: 'uk',
          value: 'en_uk',
          i18n: 'lang.english',
        },
        {
          image: 'canada',
          value: 'en_ca',
          i18n: 'lang.english',
        },
        {
          image: 'australia',
          value: 'en_au',
          i18n: 'lang.english',
        },
        {
          image: 'thailand',
          value: 'en_th',
          i18n: 'lang.english',
        },
        {
          image: 'malaysia',
          value: 'en_my',
          i18n: 'lang.english',
        },
        {
          image: 'vietnam',
          value: 'en_vn',
          i18n: 'lang.english',
        },
        {
          image: 'singapore',
          value: 'en_sg',
          i18n: 'lang.english',
        },
        {
          image: 'myanmar',
          value: 'en_mm',
          i18n: 'lang.english',
        },
        {
          image: 'indonesia',
          value: 'en_id',
          i18n: 'lang.english',
        },
        {
          image: 'mexico',
          value: 'es',
          i18n: 'lang.spanish',
        },
        {
          image: 'scotland',
          value: 'en_st',
          i18n: 'lang.english',
        },
      ],
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      flag: (state) => state.flag,
    }),
  },

  methods: {

    async changeLanguage(language, flag) {
      this.loading.lang = true;
      this.setFlag(flag);

      await updateMe({ language }, false).then(async (user) => {
        this.setUser(user);
        let lang = '';
        switch (user.language) {
          case 'en':
          case 'en_au':
          case 'en_nz':
          case 'en_uk':
          case 'en_ca':
          case 'en_id':
          case 'en_my':
          case 'en_mm':
          case 'en_sg':
          case 'en_th':
          case 'en_vn':
          case 'en_st':
            lang = 'en';
            break;
          case 'es':
            lang = 'es';
            break;
        }

        this.$i18n.locale = lang;
        this.G_changeLanguage(language);
      }).finally(() => {
        this.loading.lang = false;
      });
    },

    ...mapMutations(['setUser', 'setFlag']),

  },

  beforeCreate() {},

  created() {},

  mounted() {
  },

  beforeDestroy() {
  },

};

</script>
